// src/components/ConsultationTimer.js
import React, { useEffect } from 'react';
import { Typography } from '@mui/material';

const ConsultationTimer = ({
  consultationStarted,
  timeElapsed,
  setTimeElapsed,
}) => {
  useEffect(() => {
    let timer;
    if (consultationStarted) {
      timer = setInterval(() => {
        setTimeElapsed((prev) => prev + 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [consultationStarted]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  return (
    <Typography variant='h6' sx={{ marginBottom: 3 }}>
      Consultation Time: {formatTime(timeElapsed)}
    </Typography>
  );
};

export default ConsultationTimer;
